module.exports = __webpack_public_path__ + "img/lesotho.9fc380a6.svg";